var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Base from "../Base.js";
import ObjectHelper from "../helper/ObjectHelper.js";
const idCounts = ObjectHelper.getPathDefault(globalThis, "bryntum.idCounts", /* @__PURE__ */ Object.create(null)), idTypes = {
  string: 1,
  number: 1
};
var Identifiable_default = (Target) => {
  var _a;
  return _a = class extends (Target || Base) {
    static get declarable() {
      return [
        "identifiable"
      ];
    }
    static get configurable() {
      return {
        /**
         * The id of this object.  If not specified one will be generated. Also used for lookups through the
         * static `getById` of the class which mixes this in. An example being {@link Core.widget.Widget}.
         *
         * For a {@link Core.widget.Widget Widget}, this is assigned as the `id` of the DOM
         * {@link Core.widget.Widget#config-element element} and must be unique across all elements
         * in the page's `document`.
         * @config {String}
         * @category Common
         */
        id: ""
      };
    }
    static setupIdentifiable(cls, meta) {
      const { identifiable } = cls;
      identifiable.idMap = /* @__PURE__ */ Object.create(null);
      Reflect.defineProperty(cls, "identifiable", {
        get() {
          return identifiable;
        }
      });
    }
    doDestroy() {
      this.constructor.unregisterInstance(this);
      super.doDestroy();
    }
    changeId(id) {
      return (this.hasGeneratedId = !id) ? this.generateAutoId() : id;
    }
    updateId(id, oldId) {
      const me = this, C = me.constructor;
      oldId && C.unregisterInstance(me, oldId);
      if (!me.hasGeneratedId || C.identifiable.registerGeneratedId !== false) {
        C.registerInstance(me, id);
      }
    }
    /**
     * This method generates an id for this instance.
     * @returns {String}
     * @internal
     */
    generateAutoId() {
      return this.constructor.generateId(`b-${this.$$name.toLowerCase()}-`);
    }
    static get all() {
      return Object.values(this.identifiable.idMap);
    }
    /**
     * Generate a new id, using an internal counter and a prefix.
     * @param {String} prefix Id prefix
     * @returns {String} Generated id
     */
    static generateId(prefix = "generatedId") {
      return prefix + (idCounts[prefix] = (idCounts[prefix] || 0) + 1);
    }
    static registerInstance(instance, instanceId = instance.id) {
      const { idMap } = this.identifiable;
      if (instanceId in idMap && !this.disableThrow) {
        throw new Error("Id " + instanceId + " already in use");
      }
      idMap[instanceId] = instance;
    }
    /**
     * Unregister Identifiable instance, normally done on destruction
     * @param {Object} instance Object to unregister
     * @param {String} id The id of the instance to unregister.
     */
    static unregisterInstance(instance, id = instance.id) {
      const { idMap } = this.identifiable;
      if (idTypes[typeof instance]) {
        delete idMap[instance];
      } else if (idMap[id] === instance) {
        delete idMap[id];
      }
    }
    static getById(id) {
      const idMap = this.identifiable.idMap;
      if (idMap) {
        return idMap[id];
      }
    }
    static get registeredInstances() {
      const idMap = this.identifiable.idMap;
      return idMap ? Object.values(idMap) : [];
    }
  }, __publicField(_a, "$name", "Identifiable"), _a;
};
export {
  Identifiable_default as default
};
